import { Injectable } from "@angular/core";
import { LessonsToolsMappingService } from "./lessons-tools-mapping.service";
import { ToolsDto } from "../../tools/dtos/tools.dto";
import { GetContentItemsResponseDto } from "../dtos/get-content-items.response.dto";

@Injectable()
export class TargetLinkURICustomizationService {
    constructor(private lessonsToolsMappingService:LessonsToolsMappingService){}
    async getTargetLinkURIAsPerToolMappedTo(courseCode:string,contentItem:GetContentItemsResponseDto){
        try{
             const tool = await this.getToolForThisCourseCode(courseCode);
             const targetLinkURI = this.getTargetLinkURIForTool(tool,contentItem);
             return targetLinkURI;
        }catch(e){
            throw e;
        }
    }
    private async getToolForThisCourseCode(courseCode:string) :Promise<ToolsDto>{
          return await this.lessonsToolsMappingService.getToolForThisCourseCode(courseCode);
      }
    private getTargetLinkURIForTool(tool:ToolsDto,contentItem:GetContentItemsResponseDto): string {
          if (tool.targetLinkURICustomization === 'REDIRECT_URI')
            return this.resolveRedirectUri(tool)
          else
            return contentItem?.url ?? '';
    }
    // returns the tool-supplied redirect_uri only if it is registered for the tool; otherwise the configured URL.
    /*  the regex here basically 
        So it splits on any combination of spaces and/or commas. For example:
        "https://a.com, https://b.com  https://c.com" → ["https://a.com", "https://b.com", "https://c.com"] 
        Because + groups consecutive delimiters together, ", " (comma + space) becomes one split point rather than producing empty strings between them. This makes it tolerant of inconsistent formatting in the stored redirectURL field (comma-separated, space-separated, or a mix).
    */
    private resolveRedirectUri(tool: ToolsDto, ): string {
        const allowed = [
            ...(tool.redirectURIs?.split(/[\s,]+/) ?? [])
        ].filter((uri): uri is string => !!uri && uri !== 'N.A.');
        return allowed[0];
    }
     
}
